import type {
  RecentQuestions,
  QuestionsMultipleVersion,
  CandidateDetails,
} from 'src/types/sense-ai-panel';

import type {State} from 'src/reducers';
import {createSelector} from 'reselect';


export const selectShowMenu = (state: State): boolean =>
  // @ts-expect-error - TS2339 - Property 'showMenu' does not exist on type 'SenseAIPanelState'.
  state.senseAIPanel?.showMenu;

export const selectJdList = (state: State): boolean =>
  // @ts-expect-error - TS2339 - Property 'jdList' does not exist on type 'SenseAIPanelState'.
  state.senseAIPanel?.jdList;

export const selectPrescreeningList = (state: State): boolean =>
  // @ts-expect-error - TS2339 - Property 'prescreeningList' does not exist on type 'SenseAIPanelState'.
  state.senseAIPanel?.prescreeningList;

export const selectCompanyList = (state: State): boolean =>
  // @ts-expect-error - TS2339 - Property 'companies' does not exist on type 'SenseAIPanelState'.
  state.senseAIPanel?.companies;

export const selectQuestions = (state: State): string[] =>
  // @ts-expect-error - TS2339 - Property 'questions' does not exist on type 'SenseAIPanelState'.
  state.senseAIPanel?.questions;

export const selectRecentQuestions = (
  state: State,
): RecentQuestions | null | undefined => state.senseAIPanel?.recentQuestions;

export const selectQuestionsFromRecent: (arg1: State, id: string) => string[] =
  createSelector(
    [
      (state: State) => state.senseAIPanel.recentQuestions,
      (state: State, id: string) => id,
    ],
    // @ts-expect-error - TS2339 - Property 'recentQuestions' does not exist on type 'SenseAIPanelState'.
    (recentQuestions, id): string[] => recentQuestions[id]?.questions,
  );

export const selectTitleFromRecent: (arg1: State, id: string) => string =
  createSelector(
    [
      (state: State) => state.senseAIPanel.recentQuestions,
      (state: State, id: string) => id,
    ],
    // @ts-expect-error - TS2339 - Property 'recentQuestions' does not exist on type 'SenseAIPanelState'.
    (recentQuestions, id): string => recentQuestions[id]?.title,
  );

// @ts-expect-error - TS2339 - Property 'title' does not exist on type 'SenseAIPanelState'.
export const selectTitle = (state: State): string => state.senseAIPanel?.title;

export const selectMultipleVersionQuestions = (
  state: State,
  // @ts-expect-error - TS2339 - Property 'multipleVersionQuestions' does not exist on type 'SenseAIPanelState'.
): QuestionsMultipleVersion => state.senseAIPanel?.multipleVersionQuestions;

export const selectJobTitle = (state: State): string =>
  // @ts-expect-error - TS2339 - Property 'jobTitle' does not exist on type 'SenseAIPanelState'.
  state.senseAIPanel?.jobTitle;

export const selectResumeQuestions = (state: State): string[] =>
  // @ts-expect-error - TS2339 - Property 'resumeQuestions' does not exist on type 'SenseAIPanelState'.
  state.senseAIPanel?.resumeQuestions;

export const selectCandidateDetails = (state: State): CandidateDetails =>
  // @ts-expect-error - TS2339 - Property 'candidateDetails' does not exist on type 'SenseAIPanelState'.
  state.senseAIPanel?.candidateDetails;

export const selectUrlSuffix = (state: State): string =>
  state.senseAIPanel?.urlSuffix;
